import React from "react";
import { Alert } from "react-bootstrap";
import SuccessIcon from "../../../assets/images/success-icon.svg";
import WarningIcon from "../../../assets/images/red-warning.svg";
import "./DisplayStatus.css";

const DisplayStatus = ({ status, msg }) => {
  return (
    <>
      {status === "success" && (
        <Alert variant={status}>
          <img
            src={SuccessIcon}
            alt="success"
            className="displayStatus_statusIcon"
          />
          {msg}
        </Alert>
      )}
      {status === "error" && (
        <Alert variant="danger">
          <img
            src={WarningIcon}
            alt="success"
            className="displayStatus_statusIcon"
          />
          {msg}
        </Alert>
      )}
      {status === "warning" && <Alert variant={status}>{msg}</Alert>}
      {status === "info" && <Alert variant="primary">{msg}</Alert>}
    </>
  );
};

export default DisplayStatus;
